import { ALL_WORD, CONTENT_TYPE_LABELS } from 'global/constants';

export function getStimulusFilter() {
  return CONTENT_TYPE_LABELS.concat({
    value: ALL_WORD,
    label: 'All Stimulus Types',
  });
}
